require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./eventi-larchitettura-scolastica-nel-cantone-ticino-1945-1980.json") })
        }
      }, "path---eventi-larchitettura-scolastica-nel-cantone-ticino-1945-1980");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---eventi-larchitettura-scolastica-nel-cantone-ticino-1945-1980!./.cache/json/eventi-larchitettura-scolastica-nel-cantone-ticino-1945-1980.json
// module id = 657
// module chunks = 231608221292675